import React, { Fragment } from 'react';

import HorizontalRule from './HorizontalRule';
import {
  getDiscountedPrice,
  roundDecimal,
} from '../../../../../../_shared/utils/utils';

const DiscountSection = ({
  discountCode,
  discountRate,
  startUpFeePerSchool,
  prediscountAmount,
}) => (
  <Fragment>
    <HorizontalRule margin="1rem 0" />

    <div className="layout-row layout-align-space-between-center">
      <span>Code: {discountCode}</span>
      <span>
        {roundDecimal(discountRate, 1)}% off - ${prediscountAmount}
      </span>
    </div>
    <div className="layout-row layout-align-end-center">
      <span style={{ paddingTop: '0.2rem' }}>
        ${getDiscountedPrice(discountRate, startUpFeePerSchool)}/school
      </span>
    </div>
  </Fragment>
);

export default DiscountSection;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/DiscountSection.jsx